var firstPageMenu = {
    //全日制菜单
    fullTime: [
        {code: "M1", name: "基础信息管理", Ename: "Information Management", img: require('image/homePage/jcxx.png')},
        {code: 'M9', name: "学生管理系统", Ename: "Student Management System", img: require('image/homePage/xsgl.png'),},
        {code: 'M2', name: "教学管理系统", Ename: "Educational Management System", img: require('image/homePage/jxgl.png'),},
        {code: 'M3', name: "排课管理系统", Ename: "Course Scheduling Management System", img: require('image/homePage/pkgl.png'),},
        {code: 'M4', name: "选修课管理系统", Ename: "Elective Course Management System", img: require('image/homePage/xxk.png'),},
        {code: 'M5', name: "考务管理系统", Ename: "Examination Management System", img: require('image/homePage/kwgl.png'),},
        {code: 'M6', name: "成绩管理系统", Ename: "Result Management System", img: require('image/homePage/cjgl.png'),},
        {code: 'M7', name: "外考管理系统", Ename: "Outside The Exam Management System", img: require('image/homePage/wkgl.png'),},
        {code: 'M8', name: "评教管理系统", Ename: "Teaching Evaluation Management System", img: require('image/homePage/pjgl.png'),},
        {code: 'M10', name: "实习管理系统", Ename: "Specialty Practice Management System", img: require('image/homePage/cjcx.png'),},
        {code: 'M11', name: "竞赛管理系统", Ename: "Specialty Practice Management System", img: require('image/homePage/beiyong_5.png'),},
        {code: 'M98', name: "教师服务中心", Ename: "Teacher service Center", img: require('image/homePage/xsswzx.png'),},
        {code: 'M99', name: "学生服务中心", Ename: "Student service Center", img: require('image/homePage/xsswzx.png'),},
        {code: 'M12', name: "教研管理", Ename: "message Center", img: require('image/homePage/xsswzx.png'),},
    ],
    //职后教育菜单
    education: [
        {code: 'M13', name: "职后教育-成人教育", Ename: "message Center", img: require('image/homePage/xsswzx.png'),},
        {code: 'M14', name: "职后教育-技能认定", Ename: "Skill Recognition", img: require('image/homePage/xsswzx.png'),},
        {code: 'M15', name: "职后教育-技能培训", Ename: "message Center", img: require('image/homePage/xsswzx.png'),},
        {code: 'M16', name: "外聘教师管理", Ename: "message Center", img: require('image/homePage/xsswzx.png'),},
        {code: 'M17', name: "学生管理", Ename: "message Center", img: require('image/homePage/xsswzx.png'),},
        {code: 'M18', name: "职后教育-数据汇总", Ename: "data Summary", img: require('image/homePage/xsswzx.png'),}
    ],
    //其他菜单
    other: [
        {code: 'M19', name: "师生信息服务", Ename: "data Summary", img: require('image/homePage/xsswzx.png'),},
        {code: 'M20', name: "基础信息", Ename: "data Summary", img: require('image/homePage/xsswzx.png'),},
        {code: 'M0', name: "系统管理", Ename: "System Management", img: require('image/homePage/xtgl.png'),},
        {code: 'M100', name: "消息通知", Ename: "data Summary", img: require('image/homePage/xsswzx.png'),},
    ]
}
export default firstPageMenu;



// WEBPACK FOOTER //
// ./src/views/firstPageMenu.js